import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function ChackAr(code) {
    if (code) {
        let rsreturn
        let Url = "CSAR/ARCode?arcode=" + code;
        console.log(genURL("CSAR/ARCode", Url));
        await axios.get(genURL(Url), { timeout: 1800 }).then((res) => {
            console.log(res.data);
            let nameth = res.data[0].NAMETH
            let creditcode = res.data[0].CREDITCODE
            let arname2 = res.data[0].Arname2
            let sername = res.data[0].Surname
            let subgroup = res.data[0].SUBGROUP1
            let taxtype = res.data[0].TAXTYPE
            let ADDRESS = res.data[0].ADDRESS
            rsreturn = nameth + "|" + creditcode + "|" + arname2 + "|" + sername + "|" + subgroup + "|" + taxtype + "|" + ADDRESS
        }).catch((err) => {
            rsreturn = ""
            console.log(err);
        });
        return rsreturn
    }
};

